import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCustomerInfo } from '../../redux/services/customer-info/customer-info-service';
import {
  setAgentStatusToDisable,
  getAgentPendingApplications,
  deleteAgentApplication,
} from '../../redux/services/agent-application-info/agent-application-info-service';
import {
  setFileFromS3,
  deleteFileFromS3,
} from '../../redux/services/upload-service/upload-service';
import { getInsuranceCompanyByDetail } from '../../redux/services/insurance-comp-info/insurance-comp-info-service';
import InfoQueryForm from '../../components/Info-query/info-query-form';
import { bindActionCreators } from 'redux';
import { reset } from 'redux-form';
import ProgressIndicator from '../../components/common/progress-indicator/progress-indicator';
import AgentHomeForm from '../../components/agent-home/AgentHomeForm';
import AgentReview from '../../components/agent-review/agent-review';
import Stepper from '../../components/stepper/stepper';
import UploadContractForm from '../../components/upload-contract/UploadContractForm';

import _ from 'lodash';
class HomeContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      user: {},
      checkedValues: false,
      open: false,
      data: {},
      viewApp: false,
      insuranceInfo: undefined,
      insurNotfound: false,
      viewInfo: false,
      modalOpen: false,
      deleteId: null,
      showPDF: false,
      file: null,
      corrections: false,
      selectedId: null,
      error: null,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.hiddenFileInput = React.createRef();
    localStorage.setItem('counter', 0);
  }

  componentDidMount = () => {
    this.props.getAgentPendingApplications(this.props.token, () => {
      this.props.getInsuranceCompanyInfo(this.props.token);
    });

    if (
      this.props.location.state !== undefined &&
      this.props.location.state.page === 'query' &&
      !this.state.viewInfo
    ) {
      this.setState({
        viewInfo: true,
      });
    }
    console.log('componentDidMount--Home-props', this.props);
  };

  handleRefreshHomePage = e => {
    e.preventDefault();
    this.props.getAgentPendingApplications(this.props.token, () => {});
  };

  handleAgentHomeCancel = e => {
    e.preventDefault();
    console.log('cancel value', e.currentTarget.value);
    this.setState({ modalOpen: true });
    this.setState({ deleteId: this.trim(e.currentTarget.value) });
  };

  handleModalClose = e => {
    e.preventDefault();
    this.setState({ modalOpen: false });
  };

  handleAppDelete = e => {
    e.preventDefault();
    console.log('cancel value-2', this.state.deleteId);
    let payload = this.props.agentAppInfo.find(
      e => e.id === this.state.deleteId,
    );
    console.log('delete Payload', payload);
    this.props.deleteAgentApplication(payload, this.props.token);
    this.setState({ modalOpen: false, viewApp: false });
  };

  handleInsurCompNotFound = e => {
    e.preventDefault();
    if (!this.state.insurNotfound) {
      this.setState({ insurNotfound: true });
    } else {
      this.setState({ insurNotfound: false });
    }
  };

  trim = str => {
    if (str !== undefined) {
      let result = str.toString().replace(/,/g, '');
      return Number(result);
    }
  };

  handleView = e => {
    e.preventDefault();
    let value = this.trim(e.currentTarget.value);
    this.setState({ selectedId: value });
    let data = _.find(this.props.agentAppInfo, function (o) {
      return o.id === value;
    });
    // this.setState({ data: data, viewApp: true })
    if (data.appStatus === 'PENDING_CORRECTIONS') {
      this.props.history.push('/info', { data });
    } else if (
      data.appStatus === 'PENDING_FOR_NOTARY' ||
      data.appStatus === 'AWAITING_ORIGINALS' ||
      data.appStatus === 'REJECTED'
    ) {
      this.setState({ data: data, viewApp: true });
    }
    if (data.appStatus === 'PENDING_CONTRACT_CORRECTIONS') {
      this.setState({
        data: data,
        viewApp: true,
        viewInfo: false,
        showPDF: true,
        corrections: true,
      });
    }
  };

  handleBackForHome = e => {
    e.preventDefault();
    this.setState({ viewInfo: false });
  };

  handleBackFromPDFHome = e => {
    e.preventDefault();
    this.setState({ showPDF: false, corrections: false, viewApp: false });
  };

  handleCustomerInfoBack = e => {
    e.preventDefault();
    this.setState({ viewApp: false });
  };

  handleReviewSubmit = e => {
    e.preventDefault();
    this.setState({ showPDF: true });
  };

  handleReviewBack = e => {
    e.preventDefault();
    this.setState({ viewApp: false });
  };
  handleViewApplication = e => {
    e.preventDefault();
    if (!this.state.viewInfo) {
      this.setState({ viewInfo: true });
    }
  };

  resetStateData = () => {
    console.log('this.state.selectedId', this.state.selectedId);
    if (this.state.selectedId !== undefined) {
      console.log('this.state.selectedId-2', this.state.selectedId);
      let value = this.state.selectedId;
      let data = _.find(this.props.agentAppInfo, function (o) {
        return o.id === value;
      });
      this.setState({ data: data });
    }
  };

  handlePDFBack = e => {
    e.preventDefault();
    console.log('handlePDFBack ');
    this.setState({
      showPDF: false,
      viewInfo: false,
    });
  };

  handleUpload = e => {
    e.preventDefault();
    console.log('Upload is called-1 ', e);
    this.hiddenFileInput.current.click();
  };

  handleFile = e => {
    e.preventDefault();
    console.log('Upload is called ', e.target.files);
    if (e.target.files.length === 1) {
      this.props.setFileFromS3(
        this.state.data.companyName,
        this.state.data.bondNumber,
        e.target.files[0],
        this.props.token,
        () => {
          this.resetStateData();
        },
      );
    }
  };

  getRemainingAttempst = attempts => {
    return Number(5 - attempts);
  };

  handleContractDelete = e => {
    e.preventDefault();
    this.props.deleteFileFromS3(
      this.state.data.companyName,
      this.state.data.bondNumber,
      this.props.token,
      () => {
        this.resetStateData();
      },
    );
  };
  handleSubmit = values => {
    let attempts = parseInt(localStorage.getItem('counter'));
    console.log('Home-container', this.props);
    const { masterAcc, taxId } = values;
    this.setState({ submitted: true });
    let emailAddress;
    if (this.props.currentUser !== null) {
      emailAddress = this.props.currentUser.emailAddress;
    }
    console.log('Home-container-emailAddress', emailAddress);
    if (masterAcc && taxId) {
      this.props.getCustomerInfo(masterAcc, taxId, this.props.token);
    }
    localStorage.setItem('counter', ++attempts);
    let errorMSg =
      this.props.error +
      `You have  ` +
      this.getRemainingAttempst(parseInt(localStorage.getItem('counter'))) +
      ` attempts remaining before your user account is locked.`;
    if (parseInt(localStorage.getItem('counter')) === 3) {
      this.setState({
        error: errorMSg,
      });
    } else if (parseInt(localStorage.getItem('counter')) === 4) {
      this.setState({
        error:
          this.props.error +
          `You have  ` +
          this.getRemainingAttempst(parseInt(localStorage.getItem('counter'))) +
          ` attempt remaining before your user account is locked.`,
      });
    }
    if (parseInt(localStorage.getItem('counter')) === 5) {
      this.props.setAgentStatusToDisable(
        this.props.currentUser.emailAddress,
        this.props.token,
        () => {
          this.props.history.push('/disable');
        },
      );
    }

    this.props.reset();
  };

  render() {
    let errors = this.props.error;
    if (this.state.error !== null) {
      errors = this.state.error;
    }
    console.log('home-container', this.state);
    return this.props.isLoading ? (
      <div>
        <ProgressIndicator />
      </div>
    ) : (
      <React.Fragment>
        {this.props.agentAppInfo && this.props.agentAppInfo.length > 0 && (
          <div>
            {!this.state.viewInfo && (
              <div>
                {!this.state.viewApp && (
                  <div>
                    <AgentHomeForm
                      data={_.sortBy(this.props.agentAppInfo, function (o) {
                        return o.currentStatusTimeStamp;
                      }).reverse()}
                      handleView={this.handleView.bind(this)}
                      viewinfoPage={this.handleViewApplication.bind(this)}
                      modalOpen={this.state.modalOpen}
                      handleAgentHomeCancel={this.handleAgentHomeCancel.bind(
                        this,
                      )}
                      handleModalClose={this.handleModalClose.bind(this)}
                      handleAppDelete={this.handleAppDelete.bind(this)}
                      handleRefreshHomePage={this.handleRefreshHomePage.bind(
                        this,
                      )}
                    />
                  </div>
                )}
                {this.state.viewApp &&
                  !this.state.viewInfo &&
                  !this.state.showPDF && (
                    <div>
                      <AgentReview
                        customerInfo={this.state.data}
                        handleView={this.handleView.bind(this)}
                        insuranceInfo={this.props.insuranceInfo}
                        handleReviewSubmit={this.handleReviewSubmit.bind(this)}
                        handleReviewBack={this.handleReviewBack.bind(this)}
                        modalOpen={this.state.modalOpen}
                        handleAgentHomeCancel={this.handleAgentHomeCancel.bind(
                          this,
                        )}
                        handleModalClose={this.handleModalClose.bind(this)}
                        handleAppDelete={this.handleAppDelete.bind(this)}
                      />
                    </div>
                  )}
                {this.state.showPDF && (
                  <div>
                    <UploadContractForm
                      data={this.state.data}
                      upload={this.state.createUpload}
                      handleUpload={this.handleUpload.bind(this)}
                      handleFile={this.handleFile.bind(this)}
                      handleBack={this.handlePDFBack.bind(this)}
                      handleBackFromPDFHome={this.handleBackFromPDFHome.bind(
                        this,
                      )}
                      corrections={this.state.corrections}
                      message={this.props.message}
                      errors={this.props.error}
                      hiddenFileInput={this.hiddenFileInput}
                      handleContractDelete={this.handleContractDelete.bind(
                        this,
                      )}
                    />
                  </div>
                )}
              </div>
            )}

            {this.state.viewInfo && (
              <div>
                <Stepper activeStep={0} />
                <InfoQueryForm
                  onSubmit={this.handleSubmit.bind(this)}
                  submitted={this.state.submitted}
                  errors={errors}
                  handleBackForHome={this.handleBackForHome}
                  back={'true'}
                />
              </div>
            )}
          </div>
        )}

        {this.props.agentAppInfo && this.props.agentAppInfo.length === 0 && (
          <div>
            <Stepper activeStep={0} />
            <InfoQueryForm
              onSubmit={this.handleSubmit.bind(this)}
              submitted={this.state.submitted}
              errors={errors}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.appReducer.currentUser,
  token: state.appReducer.token,
  error:
    state.customerInfoReducer.error === undefined
      ? state.agentApplicationInfoReducer.error
      : state.customerInfoReducer.error,
  isLoading:
    state.agentApplicationInfoReducer.isLoading === undefined
      ? state.customerInfoReducer.isLoading
      : state.agentApplicationInfoReducer.isLoading,
  agentAppInfo: state.agentApplicationInfoReducer.applicationInfo,
  insuranceInfo: state.insuranceReducer.insuranceInfo,
  message: state.agentApplicationInfoReducer.message,
});

const mapDispatchToProps = dispatch => ({
  getCustomerInfo: bindActionCreators(getCustomerInfo, dispatch),
  getInsuranceCompanyInfo: bindActionCreators(
    getInsuranceCompanyByDetail,
    dispatch,
  ),
  getAgentPendingApplications: bindActionCreators(
    getAgentPendingApplications,
    dispatch,
  ),
  setAgentStatusToDisable: bindActionCreators(
    setAgentStatusToDisable,
    dispatch,
  ),
  deleteAgentApplication: bindActionCreators(deleteAgentApplication, dispatch),
  reset: () => dispatch(reset('infoQueryForm')),
  setFileFromS3: bindActionCreators(setFileFromS3, dispatch),
  deleteFileFromS3: bindActionCreators(deleteFileFromS3, dispatch),
});

HomeContainer.propTypes = {
  setAgentStatusToDisable: PropTypes.func,
  error: PropTypes.object,
  getCustomerInfo: PropTypes.func,
  getInsuranceCompanyInfo: PropTypes.func,
  getAgentPendingApplications: PropTypes.func,
  deleteAgentApplication: PropTypes.func,
  currentUser: PropTypes.shape({
    emailAddress: PropTypes.string,
  }),
  reset: PropTypes.func,
  isLoading: PropTypes.bool,
  agentAppInfo: PropTypes.array,
  insuranceInfo: PropTypes.array,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  token: PropTypes.string,
  setFileFromS3: PropTypes.func,
  deleteFileFromS3: PropTypes.func,
  message: PropTypes.string,
  location: PropTypes.shape({
    state: PropTypes.shape({
      page: PropTypes.string,
    }),
  }),
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);
